import { t } from 'i18next'; // o desde un hook si lo necesitas
import { data } from 'react-router';

export const handlerErrorResponse = (error) => {
  console.log(error);
  const dataError = {
    status: error.status,
    message: 'Error desconocido',
    details: error,
    messageFormatted: '',
    action: '',
  };
  if (error) {
    if (error?.status === 400 && error?.data?.message) {
      console.log(error.data);
      // Si el mensaje es un array, lo convertimos en texto
      if (Array.isArray(error.data.message)) {
        // dataError.message = error.data.message.join('\n'); // Unir con saltos de línea
        // Otra opción: Separar por viñetas
        dataError.message = error.data.message;
        dataError.messageFormatted = error.data.message.map((msg) => `• ${msg}`).join('\n');
      }

      if (error.data.message !== '') {
        dataError.message = error.data.message;
        dataError.messageFormatted = error.data.message;
      } else {
        dataError.message = error.data.message;
        dataError.messageFormatted = t('TXT_ERROR_STATUS_400');
      }

      if (error?.data?.errorCode) {
        if (error.data.errorCode !== '' && error.data.errorCode === 101) {
          dataError.action = 'FRONT';
        }
      }
    }
    // else if (error.status === 400 && error?.data?.message) {
    // dataError.message = error.data.message; }
    else if (error.status === 401) {
      dataError.message = t('TXT_ERROR_UNAUTHORIZED');
      dataError.messageFormatted = t('TXT_ERROR_UNAUTHORIZED');
      dataError.action = 'INIT';
    } else if (error.status === 500) {
      dataError.message = error.data.message;
      dataError.messageFormatted = t('TXT_ERROR_STATUS_CODE_500');
    } else if (error.status === 'FETCH_ERROR') {
      dataError.message = error.message;
      dataError.messageFormatted = t('TXT_STATUS_FETCH_ERROR');
    }
    // else if (error?.status === 404) {
    //   return <div>Error: No se encontraron posts.</div>;
    // } else if (error?.status === 500) {
    //   return <div>Error: Problema en el servidor. Inténtalo de nuevo más tarde.</div>;
    // } else {
    //   return <div>Error desconocido: {error?.status}</div>;
    // }
  }

  return dataError;
};

export const handleResponse = (response) => response;
